import { Col, Row } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { HideIfNotAllowed } from 'components/organisms/permission-controller';
import { PermissionRuleName } from 'constant';

export const Title: FC<{ projectId: number }> = ({ projectId }) => {
  return (
    <Row>
      <Col flex={1}>
        <strong>
          <FormattedMessage id="all_phases" />
        </strong>
      </Col>
      <HideIfNotAllowed ruleName={PermissionRuleName.ProjectPlanPage}>
        <a
          href={`/projects/${projectId}`}
          target="_blank"
          rel="noopener noreferrer"
          data-cy="view.project.plan-button.cta"
        >
          <FormattedMessage id="project.overview.all_phases.cta" />
        </a>
      </HideIfNotAllowed>
    </Row>
  );
};
